import { queryTagApp as queryTagAppHttp } from '@wix/ambassador-devcenter-appmarket-v1-tag-app/http';
import type {
  QueryTagAppRequest,
  QueryTagAppResponse,
} from '@wix/ambassador-devcenter-appmarket-v1-tag-app/types';
import type { Essentials } from '../models';
import { isSSR } from '../utils/is-ssr';

export async function queryTagApp({
  httpClient,
  rpcClient,
  payload,
}: {
  httpClient: Essentials['httpClient'];
  rpcClient?: Essentials['rpcClient'];
  payload: QueryTagAppRequest;
}): Promise<QueryTagAppResponse> {
  if (isSSR() && rpcClient !== undefined) {
    const queryTagAppRpc = (
      await import('@wix/ambassador-devcenter-appmarket-v1-tag-app/rpc')
    ).queryTagApp;
    return rpcClient.request(queryTagAppRpc(payload));
  }

  const { data: queryTagResponse } = await httpClient.request(
    queryTagAppHttp(payload),
  );

  return queryTagResponse;
}
